import React from "react";
import { List, Datagrid, TextField } from "react-admin";

export const UserBadgeList = ({ permissions, ...props }) => {
  return (
    <List {...props} bulkActionButtons={false} title="UserBadge">
      <Datagrid rowClick="show">
        <TextField source="badgeName" />
        <TextField source="badgeDescription" />
      </Datagrid>
    </List>
  );
};
export default UserBadgeList;
